<template>
  <div v-if="isLoaded">
    <div class="wraper" v-if="!isProjectLoading">
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <ProjectHeader></ProjectHeader>

        <div class="row myrow">
          <div class="col-xs-12 mycol" style="padding-top: 10px;">
            <div class="pull-right">
              <a
                v-if="currentUser.IS_EXPERT_USER == 0 && isExpertiseViewButton"
                target="_blank"
                :href="
                  'http://reporting/ReportServer/Pages/ReportViewer.aspx?/Отчеты/ДП/Результаты проведения экспертиз (светофор)&number=' +
                    project.UF_NUMBER +
                    '&rs:Command=Render&rc:Toolbar=true'
                "
                class="btn btn-success"
                style="margin-right: 12px"
              >
                Результаты проведения экспертиз
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div
        v-if="isLoadingComponent && expertise.length > 0"
        style="padding: 20px 30px;"
        class="row myrow"
      >
        <div class="col-xs-12 mycol">
          <div class="table-responsive">
            <table class="expert-project-table table-hover">
              <thead>
                <tr>
                  <th style="width: 15%">Дата назначения</th>
                  <th style="width: 20%">Кем создана</th>
                  <th style="width: 15%">Статус</th>
                  <th style="width: 10%">Вид экспертизы</th>
                  <th style="width: 10%"></th>
                  <th style="width: 20%">Эксперт</th>
                  <th style="width: 10%">Экспертиза</th>
                </tr>
              </thead>
              <tbody
                v-for="item in expertise"
                :key="item.CODE_EXPERTISE"
                class="contoll-tbody-item"
                :class="{ active: !expandedItems[item.CODE_EXPERTISE] }"
              >
                <tr class="contoll-tr-item">
                  <td class="stl-bold" colspan="7">
                    <span @click="toggleExpand(item)">
                      <span class="icon-open-arrow-black" />
                      {{ item.NAME_EXPERTISE }}
                    </span>
                    <a
                      v-if="isExpertiseEditable"
                      class="add-butt-black"
                      @click.prevent="openExpertiseModal(item)"
                    />
                  </td>
                </tr>

                <template v-if="item.EXPERTISE_LIST.length > 0">
                  <tr
                    v-for="expert in item.EXPERTISE_LIST"
                    :key="expert.EXPERTISE_ID"
                    class="contoll-tr-item__inner"
                  >
                    <td>
                      <router-link
                        :to="{
                          name: 'ExpertiseDetails',
                          params: {
                            id: $route.params.id,
                            expertiseId: expert.EXPERTISE_ID
                          }
                        }"
                      >
                        {{ expert.UF_DATE_START_EXPERT }}
                      </router-link>
                    </td>
                    <td>
                      {{ expert.MANAGER_CREATE_INFO.UF_MANAGER_GREATE_NAME }}
                      <template
                        v-if="expert.MANAGER_CREATE_INFO.UF_GROUP_GREATE_NAME"
                      >
                        роль "{{
                          expert.MANAGER_CREATE_INFO.UF_GROUP_GREATE_NAME
                        }}"
                      </template>
                    </td>
                    <td>
                      {{ getExpertiseStatusName(expert.UF_EXPERT_STATUS_ID) }}
                      <template v-if="expert.IS_VIEW_DOP_EXPERT == 1">
                        <br />Дополнительная экспертиза:<br />
                        {{
                          getExpertiseStatusName(expert.UF_EXPERT_STATUS_DOP_ID)
                        }}
                      </template>
                    </td>
                    <td>
                      <div v-if="expert.UF_TIME_STATUS_CREATE_ID > 0">
                        <template
                          v-for="spTime in directory.sp_time_status_set_expertise"
                        >
                          <span
                            v-if="spTime.ID == expert.UF_TIME_STATUS_CREATE_ID"
                          >
                            {{ spTime.NAME }}
                          </span>
                        </template>
                      </div>
                    </td>
                    <td>
                      <div v-if="expert.UF_SUPTYPE_EXPERTISE_ID > 0">
                        <template
                          v-for="spTime in item.SUBTYPE_LIST_ALL"
                          v-if="spTime.ID == expert.UF_SUPTYPE_EXPERTISE_ID"
                        >
                          <span>{{ spTime.UF_NAME }}</span>
                        </template>
                      </div>
                    </td>
                    <td>{{ expert.UF_EXPERT_NAME }}</td>
                    <td>
                      <a
                        v-if="
                          expert.FILE_INFO.FILE && expert.FILE_INFO.FILE.FILE
                        "
                        :href="expert.FILE_INFO.FILE.FILE"
                        target="_blank"
                        >Скачать</a
                      >
                    </td>
                  </tr>
                </template>
                <template v-if="item.EXPERTISE_LIST.length === 0">
                  <tr class="contoll-tr-item__inner">
                    <td>Нет назначенных экспертиз</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Создание экспертизы -->
    <div
      v-if="showExpertiseModal"
      class="modal fade in show"
      id="expertise-modal"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog modal-dialog-sm modal-new-style modal-dialog-centered"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header close-active">
            <button
              type="button"
              class="close"
              @click="closeExpertiseModal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              Создание экспертизы, {{ selectedExpertiseType.NAME_EXPERTISE }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label class="title-bold stl-mb-10"
                >Тип экспертизы <span class="stl-clr-red">*</span></label
              >
              <select
                v-model="selectedExpertiseTypeId"
                class="form-control"
                @change="onExpertiseTypeChange"
              >
                <option
                  v-for="type in expertise"
                  :key="type.ID_TYPE_EXPERTISE"
                  :value="type.ID_TYPE_EXPERTISE"
                >
                  {{ type.NAME_EXPERTISE }}
                </option>
              </select>
            </div>

            <div
              v-if="!selectedExpertiseType.IS_ONLY_SET_DIRECTOR"
              class="form-group"
            >
              <label
                >Эксперт
                <span
                  class="stl-clr-red"
                  v-if="!selectedExpertiseType.IS_NOT_SET_EXPERT"
                  >*</span
                ></label
              >
              <select v-model="selectedExpertId" class="form-control">
                <option
                  v-for="expert in experts[selectedExpertiseTypeId]"
                  :key="expert.ID"
                  :value="expert.ID"
                >
                  {{ expert.NAME }}
                </option>
              </select>
            </div>

            <div
              v-if="
                selectedExpertiseType.IS_SET_VARIANT_DOP_EXPERTISE === 1 &&
                  selectedExpertiseType.IS_ONLY_SET_DIRECTOR === 1
              "
              class="form-group"
            >
              <label>Вариант проведения экспертизы:</label>
              <select v-model="selectedVariantId" class="form-control">
                <option
                  v-for="variant in DtypeZalogExpertise"
                  :key="variant.ID"
                  :value="variant.ID"
                >
                  {{ variant.NAME }}
                </option>
              </select>
            </div>

            <div
              v-if="selectedExpertiseType.IS_NEED_SET_SUBTYPE === 1"
              class="form-group"
            >
              <label
                >Подтип экспертизы <span class="stl-clr-red">*</span></label
              >
              <select v-model="selectedSubtypeId" class="form-control">
                <option
                  v-for="subtype in selectedExpertiseType.SUBTYPE_LIST"
                  :key="subtype.ID"
                  :value="subtype.ID"
                >
                  {{ subtype.UF_NAME }}
                </option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="butt-stl butt-black"
              @click="closeExpertiseModal"
            >
              Отмена
            </button>
            <button
              type="button"
              class="butt-stl butt-blue"
              @click="createExpertise"
              :disabled="isCreatingExpertise"
            >
              Создать
            </button>
          </div>
        </div>
      </div>
    </div>
    <project-menu></project-menu>
    <!-- /.modal -->
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import {
  FETCH_PROJECT,
  FETCH_DIRECTORY,
  FETCH_DIRECTORIES
} from "@/store/actions.type";
import ProjectHeader from "@/components/project/partial/ProjectHeader";
import { ExpertiseService, ProjectsService } from "@/common/api.service";
import { FETCH_EXPERTISES } from "@/store/actions.type";
import { AUTH_URL } from "@/common/config";
import UploadExperFile from "./documents/UploadExperFile";
import ProjectMenu from "@/components/project/partial/ProjectMenu";
import Multiselect from "vue-multiselect";

export default {
  name: "ExpertStatus",
  title: "Статус экспертиз проекта",
  data() {
    return {
      expandedItems: {},
      showExpertiseModal: false,
      selectedExpertiseTypeId: null,
      selectedExpertId: null,
      selectedVariantId: null,
      selectedSubtypeId: null,
      showExpertSelector: false,
      expertLoaded: false,
      experts: null,
      siteUrl: "",
      expChecked: null,
      isExpertiseEditable: false,
      isExpertiseView: false,
      isExpertiseViewButton: false,
      type_provision_sp: "",
      isLoadingComponent: false,
      resultECP: {},
      result: "",
      showDocHistoryDialog: false,
      documentHistory: [],
      MPTData: {
        UF_IS_MPT: 0,
        UF_DEPARTAMENT_ID: 0,
        IS_CHANGE_DEPARTAMENT: 1,
        UF_COMMENT_MPT: ""
      },
      isViewSconditionDZList: [],
      // tosterErrors: [],
      isCreatingExpertise: false,
      isLoaded: false
    };
  },

  components: {
    ProjectMenu,
    ProjectHeader,
    UploadExperFile,
    Multiselect
  },

  computed: {
    ...mapGetters([
      "project",
      "isLoading",
      "directory",
      "currentUser",
      "expertise",
      "DTypeProvision",
      "DtypeZalogExpertise"
    ]),
    selectedExpertiseType() {
      return (
        this.expertise.find(
          type => type.ID_TYPE_EXPERTISE === this.selectedExpertiseTypeId
        ) || {}
      );
    }
  },

  async created() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");
    this.$store.dispatch(FETCH_DIRECTORIES, [
      "status",
      "status_expertise",
      "type_provision_sp",
      "sp_variant_zalog_expertise",
      "sp_duration_expertise",
      "departaments",
      "sp_time_status_set_expertise",
      "sp_expertise_type_fie",
      "sp_expertise_type_pre"
    ]);

    this.$store.dispatch(FETCH_DIRECTORY, ["program_fin_support"]).then(() => {
      this.fetchProject();
      this.isLoadingComponent = true;
    }, this);
  },

  methods: {
    openExpertiseModal(item) {
      this.selectedExpertiseTypeId = item.ID_TYPE_EXPERTISE;
      this.showExpertiseModal = true;
    },

    closeExpertiseModal() {
      this.showExpertiseModal = false;
      this.resetModalData();
    },

    resetModalData() {
      this.selectedExpertiseTypeId = null;
      this.selectedExpertId = null;
      this.selectedVariantId = null;
      this.selectedSubtypeId = null;
    },

    onExpertiseTypeChange() {
      this.selectedExpertId = null;
      this.selectedVariantId = null;
      this.selectedSubtypeId = null;
    },

    createExpertise() {
      if (this.isCreatingExpertise) return;

      this.isCreatingExpertise = true;

      this.addExpertise(
        this.selectedVariantId,
        null,
        this.selectedExpertiseTypeId,
        this.selectedExpertiseType.VID_EXPERTISE,
        null,
        this.selectedExpertId,
        this.selectedSubtypeId
      )
        .then(() => {
          this.closeExpertiseModal();
        })
        .finally(() => {
          this.isCreatingExpertise = false;
        });
    },

    addExpertise(
      dopExpertiseId,
      durationExpertiseId,
      typeId,
      vidId,
      typeProvisionId,
      expertId,
      subtypeId
    ) {
      return new Promise((resolve, reject) => {
        ExpertiseService.addMainDocESExpertise(this.$route.params.id, {
          UF_VARIANT_DOP_EXPERTISE_ID: dopExpertiseId,
          UF_DURATION_EXPERTISE_ID: durationExpertiseId,
          UF_EXPERTISE_TYPE_ID: typeId,
          UF_EXPERTISE_VID_ID: vidId,
          UF_TYPE_PROVISION_ID: typeProvisionId,
          UF_EXPERT_ID: expertId,
          UF_SUPTYPE_EXPERTISE_ID: subtypeId
        }).then(({ data }) => {
          if (!data.error) {
            this.fetchExpertise().then(() => {
              this.$toasted.show("Экспертиза создана", {
                theme: "green",
                position: "bottom-right",
                duration: 3500
              });
              resolve();
            });
          } else {
            data.errorArr.forEach(text => {
              this.$toasted.show(text, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            });
            reject(data.errorArr);
          }
        });
      });
    },

    toggleExpand(item) {
      this.$set(
        this.expandedItems,
        item.CODE_EXPERTISE,
        !this.expandedItems[item.CODE_EXPERTISE]
      );
    },

    async fetchProject() {
      await this.$store.dispatch(FETCH_PROJECT, this.$route.params.id);
      await ProjectsService.getRulesChangeStatusUser(
        this.project.UF_STATUS_ID
      ).then(({ data }) => {
        this.isExpertiseEditable = data.IS_EDIT_PANEL_EXPERTISE;
        this.isExpertiseView = data.IS_VIEW_PANEL_EXPERTISE;
        this.isExpertiseViewButton = data.IS_VIEW_RES_EXPERTISE_BUTTON;
        if (this.isExpertiseView || this.isExpertiseEditable) {
          this.isLoaded = true;
        }
      }, this);
      await this.fetchExpertise();
      await this.fetchMPT();
      this.isLoadingComponent = true;
    },

    async fetchExpertise() {
      const currentExpandedState = { ...this.expandedItems };

      await this.$store.dispatch(FETCH_EXPERTISES, this.$route.params.id);

      if (this.expChecked === null) {
        this.expChecked = [];
        Object.keys(this.expertise).forEach(e => {
          Vue.set(this.expChecked, e, this.expertise[e].EXPERTISE_ADDED);
        });
      }

      if (this.experts === null) {
        this.experts = {};
        await Promise.all(
          Object.keys(this.expertise).map(async e => {
            const experts = await this.expertList(
              this.expertise[e].ID_TYPE_EXPERTISE,
              this.expertise[e].VID_EXPERTISE
            );
            Vue.set(this.experts, this.expertise[e].ID_TYPE_EXPERTISE, experts);
          })
        );
      }

      this.isViewSconditionDZList = new Map();
      this.expertise.forEach(exp => {
        this.$set(
          this.expandedItems,
          exp.CODE_EXPERTISE,
          currentExpandedState[exp.CODE_EXPERTISE] || false
        );
        if (exp.IS_SET_TYPE_FIE_DZ == 1) {
          const idTemp = this.directory.sp_expertise_type_fie.find(
            c => c.CODE == "suspensive_condition"
          );

          exp.EXPERTISE_LIST.forEach(expert => {
            const flag = expert.UF_TYPE_FIE_ID == idTemp.ID;
            this.isViewSconditionDZList.set(expert.EXPERTISE_ID, flag);
          });
        }
      });

      this.isLoadingComponent = true;
    },

    async fetchMPT() {
      ProjectsService.getZakluchenieMinProm(this.$route.params.id).then(
        ({ data }) => {
          this.MPTData = data;
        }
      );
    },

    expertList: async function(id, vidId) {
      return ExpertiseService.getListExpertMainDocESExpertise(
        id,
        vidId,
        this.project.ID
      ).then(({ data }) => data);
    },

    getExpertiseStatusName: function(id) {
      let t = this.directory.status_expertise.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].NAME;
      }
      return "";
    }
  }
};
</script>

<style scoped></style>
